import React from "react";
import { MetroSpinner } from "react-spinners-kit";


/* Loader Component (Global Loader which is loading before every page render) */

const SpinLoader = () => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <MetroSpinner size={130} color="#ed7d31" loading={true} />
    </div>
  );
};
export default SpinLoader;
